<script lang="ts">
	import { format } from 'svelte-i18n';
	import type { EnergyTariffRemark } from 'src/types/EnergyTariff';
	import { Popover, Text, Icon } from '@Shelly/shelly-design-system';

	import DOMPurify from 'dompurify';

	export let remarks: EnergyTariffRemark[];
	export let variant: 'light' | 'dark' = 'light';
</script>

<div
	class="tariff-remarks"
	class:variant-light={variant === 'light'}
	class:variant-dark={variant === 'dark'}
>
	{#if remarks && Array.isArray(remarks) && remarks.length > 0}
		<Text styleType="body-small" class="remarks-list-container">
			<ul class="remarks-list">
				{#each remarks.slice(0, 4) as remark}
					<li class="d-flex cursor-pointer align-items-center">
						{#if remark.content.tooltip}
							<Popover
								hideCloseBtn={true}
								placement="top"
								type="hover"
								fixedWidth
								hideSlotFooter
								title={DOMPurify.sanitize(remark.content.tooltip.header)}
							>
								<div>
									<Icon
										size="xxs"
										icon="fa-solid fa-circle-info"
										variant="help"
										class="remark-info-icon"
										aria-label={$format('remark_tooltip', {
											default: 'Zusätzliche Informationen',
											locale: 'de',
										})}
									/>

									{@html DOMPurify.sanitize(remark.content.text)}
								</div>
								<svelte:fragment slot="customContent">
									<Text styleType="body-small">
										{@html DOMPurify.sanitize(remark.content.tooltip.body)}
									</Text>
								</svelte:fragment>
							</Popover>
						{:else}
							{@html DOMPurify.sanitize(remark.content.text)}
						{/if}
					</li>
				{/each}
			</ul>
		</Text>
	{/if}
</div>

<style>
	.remarks-list {
		list-style: none;
		padding: 0;
		gap: 4px;
	}
</style>
